import { render, staticRenderFns } from "./NumberedList.vue?vue&type=template&id=18212198&"
import script from "./NumberedList.vue?vue&type=script&setup=true&lang=js&"
export * from "./NumberedList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports